import {Injectable} from '@angular/core';
import {AResourceService} from "./a-resource.service";
import {FiscalPositionModel} from "../../models/resources/fiscal-position.model";
import {LanguageService} from "./language.service";
import {UrlParamModel} from "../../models/url-param.model";

@Injectable({
  providedIn: 'root',
})
export class FiscalPositionService extends AResourceService<FiscalPositionModel> {
  constructor(private languageService: LanguageService) {
    super('/fiscal-positions', false);
  }

  protected override getDefaultListParams(): UrlParamModel[] {
    const code = this.languageService.activeLanguage()?.code;
    if (!code) {
      return [];
    }
    return [{key: 'lang', value: code}];
  }
}
